export default {
  computed: {
    filters() {
      return this.$store.state.report.filters;
    },
    subtitle() {
      const subtitle = [this.filters.dates.from];
      if (
        this.filters.dates.to &&
        this.filters.dates.to !== this.filters.dates.from
      ) {
        subtitle.push(this.filters.dates.to);
      }
      return subtitle
        .map((date) => {
          return this.localeDate(date);
        })
        .join(" - ");
    },
  },
};
